<ng-container *ngIf="(currentOrder$ | async) as currentOrder">
  <gen-aberrations-wrapper class="aberrations-wrapper genomic-aberrations" [revisionId]="revisionId" [currentOrder]="currentOrder" [currentWorkflow]="currentOrder.workflowRequest"></gen-aberrations-wrapper>
</ng-container>
